import { ReactNode } from 'react'

import { Field, FieldProps, useControlId } from './Field'

export type RadioOption<Value extends string> = { value: Value; label: ReactNode }

/**
 * The `circle` and `check` spans are Material Kit's radio: the real input is
 * hidden and those two draw the control, so dropping them leaves nothing visible.
 */
export function RadioGroup<Value extends string>({
  label,
  error,
  hint,
  labelStyle = 'plain',
  className,
  style,
  id,
  name,
  value,
  onChange,
  options,
  inline = true,
}: FieldProps & {
  name: string
  value: Value | null
  onChange: (value: Value) => void
  options: readonly RadioOption<Value>[]
  inline?: boolean
}) {
  const controlId = useControlId(id)

  return (
    <Field label={label} error={error} hint={hint} labelStyle={labelStyle} className={className} style={style} controlId={controlId}>
      <div className="controls">
        {options.map((option) => (
          <div key={option.value} className="radio" style={inline ? { display: 'inline-block' } : undefined}>
            <label>
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={() => onChange(option.value)}
              />
              <span className="circle" />
              <span className="check" /> {option.label}
            </label>
          </div>
        ))}
      </div>
    </Field>
  )
}
